// A `<select>`, styled, and deliberately still a `<select>`.
//
// shadcn ships a Select built on Base UI, and it is the better control for a long or
// searchable list. These are not that: "annual or unpaid", "which of your two
// employments", "which expense category" — short, closed sets where the platform's own
// control is the one people already know.
//
// Keeping the native element buys three things a custom listbox has to re-earn: the
// phone's native picker, the keyboard behaviour every OS already implements, and a
// form that submits without JavaScript. It also keeps `userEvent.selectOptions`
// working, which is how every one of these is tested.
//
// Styled to match the Input it sits beside, because a form where two controls of the
// same height look like different products is the drift a component layer exists to
// stop.

import type { ComponentPropsWithoutRef } from "react";
import { cn } from "@/lib/utils";

export function NativeSelect({ className, ...rest }: ComponentPropsWithoutRef<"select">) {
  return (
    <select
      data-slot="native-select"
      className={cn(
        "h-8 w-full min-w-0 rounded-md border border-input bg-surface-panel px-2 py-1 text-shell-body",
        // NOT `outline-none`. It killed the document's own focus outline — the one
        // indicator in this product that measures 4.39:1 — and left only the generated
        // ring behind it. A control that removes the outline has to draw its own, and
        // this one did not.
        "transition-[color,box-shadow]",
        "focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-focus-color",
        "disabled:cursor-not-allowed disabled:opacity-50",
        "aria-invalid:border-destructive aria-invalid:ring-surface-negative-border",
        className,
      )}
      {...rest}
    />
  );
}
